// extracted by mini-css-extract-plugin
export default {"container":"SerieItem_container__DzKiV","serieImage":"SerieItem_serieImage__fs0ED","imageContainer":"SerieItem_imageContainer__ZwKuV"};